import axios from "axios";
import store from "../../store/index";

function firstDefined() {
  for (var i = 0; i < arguments.length; i++) {
    var val = arguments[i];
    if (val !== undefined && val !== null) {
      return val;
    }
  }
  return undefined;
}

const emptyForm = () => ({
  moduleId: '',
  moduleCode: '',
  moduleName: '',
  description: '',
  displayOrder: 0,
  icon: '',
  route: '',
  category: '',
  isActive: true,
  isSystemModule: false,
  tenantConfigurable: true,
  licenseRequired: false,
  defaultEnabled: true,
  version: 1,
  tags: []
});

const emptyErrors = () => ({
  moduleId: '',
  moduleCode: '',
  moduleName: '',
  displayOrder: ''
});

export default {
  name: 'ModuleModal',

  data() {
    return {
      baseUrl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      isShowModuleModal: false,
      isEditMode: false,
      isSubmitting: false,
      tagsInput: '',
      editingRecordId: '',

      formData: emptyForm(),

      errors: emptyErrors()
    };
  },

  methods: {
    openModuleModal(module) {
      this.resetForm();

      if (module) {
        this.isEditMode = true;
        this.editingRecordId = firstDefined(module.id, '');
        this.formData = {
          moduleId: firstDefined(module.moduleId, ''),
          moduleCode: firstDefined(module.code, module.moduleCode, ''),
          moduleName: firstDefined(module.name, module.moduleName, ''),
          description: firstDefined(module.description, ''),
          displayOrder: firstDefined(module.order, module.displayOrder, 0),
          icon: firstDefined(module.icon, ''),
          route: firstDefined(module.route, ''),
          category: firstDefined(module.category, ''),
          isActive: firstDefined(module.active, module.isActive, true),
          isSystemModule: firstDefined(module.isSystemModule, false),
          tenantConfigurable: firstDefined(module.tenantConfigurable, true),
          licenseRequired: firstDefined(module.licenseRequired, false),
          defaultEnabled: firstDefined(module.defaultEnabled, true),
          version: firstDefined(module.version, 1),
          tags: firstDefined(module.tags, [])
        };
        this.tagsInput = this.formData.tags.join(', ');
      } else {
        this.isEditMode = false;
      }

      this.isShowModuleModal = true;
    },

    closeModuleModal() {
      this.isShowModuleModal = false;
      this.resetForm();
    },

    resetForm() {
      this.formData = emptyForm();
      this.tagsInput = '';
      this.editingRecordId = '';
      this.errors = emptyErrors();
    },

    // Only called from validateForm() at submit time — no more @blur triggers,
    // so errors stay hidden until the user actually clicks Save.
    validateField(fieldName) {
      const field = this.formData[fieldName];

      switch (fieldName) {
        case 'moduleId':
          if (!field || String(field).trim().length === 0) {
            this.errors.moduleId = 'Module ID is required';
          } else {
            this.errors.moduleId = '';
          }
          break;
        case 'moduleName':
          if (!field || String(field).trim().length === 0) {
            this.errors.moduleName = 'Module name is required';
          } else if (String(field).trim().length < 3) {
            this.errors.moduleName = 'Module name must be at least 3 characters';
          } else {
            this.errors.moduleName = '';
          }
          break;
        case 'moduleCode':
          if (!field || String(field).trim().length === 0) {
            this.errors.moduleCode = 'Module code is required';
          } else {
            this.errors.moduleCode = '';
          }
          break;
        case 'displayOrder':
          if (field !== null && field !== '' && isNaN(field)) {
            this.errors.displayOrder = 'Display order must be a number';
          } else {
            this.errors.displayOrder = '';
          }
          break;
      }
    },

    validateForm() {
      let isValid = true;

      ['moduleId', 'moduleCode', 'moduleName', 'displayOrder'].forEach(field => {
        this.validateField(field);
        if (this.errors[field]) {
          isValid = false;
        }
      });

      return isValid;
    },

    buildPayload() {
      const tags = this.tagsInput
        .split(',')
        .map(t => t.trim())
        .filter(t => t.length > 0);

      const payload = {
        ...this.formData,
        tags
      };

      // Some update endpoints read the record's GUID from the body itself,
      // not just the query string — include it defensively when editing.
      if (this.isEditMode && this.editingRecordId) {
        payload.id = this.editingRecordId;
      }

      return payload;
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;
      const payload = this.buildPayload();

      try {
        const response = this.isEditMode
          ? await axios.put(
              `${this.baseUrl}/admin/appmodule/update?id=${encodeURIComponent(this.editingRecordId)}`,
              payload,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${this.idToken}`
                }
              }
            )
          : await axios.post(
              `${this.baseUrl}/admin/appmodule/create`,
              payload,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${this.idToken}`
                }
              }
            );

        this.$emit(this.isEditMode ? 'module-updated' : 'module-created', response.data);
        alert(this.isEditMode ? 'Module updated successfully' : 'Module created successfully');
        this.closeModuleModal();
      } catch (error) {
        const responseData = error.response && error.response.data;
        const message = (responseData && responseData.message) || error.message || 'Failed to save module';
        alert(`Error: ${message}`);
        console.error('Error saving module:', error);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};